import { setProps } from '../props';

export default (props) => async () => {

  setProps(props);
  
}